<template>
<div class="chapter">
<div class="inner_page">
<a id="VPS-3">
<h1 class="title">Siege Warfare during the Crusades</h1>
<p class="author">Michael S. Fulton</p>
<div class="img_container">
<img alt="image" src="images/Img_3_001.jpg"/>
</div>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Title.vue?0d84b863